import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Calculator from './pages/Calculator';
import Results from './pages/Results';
import Settings from './pages/Settings';
import Header from './components/Header';
import Footer from './components/Footer';
import { AppProvider } from './context/AppContext';
import './styles/globals.css';

const App: React.FC = () => {
  return (
    <AppProvider>
      <Router>
        <Header />
        <main>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/calculator" component={Calculator} />
            <Route path="/results" component={Results} />
            <Route path="/settings" component={Settings} />
          </Switch>
        </main>
        <Footer />
      </Router>
    </AppProvider>
  );
};

export default App;
